/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface HrLeaveApprovedHistory { 
    id?: string;
    hr_leave_id?: string;
    approver_id?: string;
    approved_status_id?: string;
    created_by?: string;
    created_at?: Date;
    comment?: string;
}